import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  CardHeader,
  Media,
  Input,
  Badge,
} from "reactstrap";
import {
  faAngleDown,
  faAngleUp,
  faCheck,
  faCog,
  faHome,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Card,
  Table,
  Button,
  ButtonGroup,
  Breadcrumb,
} from "@themesberg/react-bootstrap";
import {  getEmployees } from "../../services/employeeService";
import {  getTrainings } from "../../services/trainingService";
import SpinDiv from "../components/SpinDiv";
import { AddTraining } from "./AddTraining";
import moment from "moment";
import { throttle,debounce } from "./debounce";
import 'antd/dist/antd.css';
import { Pagination } from 'antd';
import EditTraining from "./EditTraining";
import DeleteTraining from "./DeleteTraining";
import { Progress } from 'antd';

const p = JSON.parse(localStorage.getItem('permissions'));

export class TrainingIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      page: 1,
      rows: 10,
      loading: false,
      employees: [],
      trainers:[],
      branches:[],
      training_types:[],
      trainings:[],
      total: 0,
      user:JSON.parse(localStorage.getItem('user')),
      permission: p !== null ?  p.map((p, index)=>{ return p.name}).includes('show setting') :[]

    

    };
    this.searchDebounced = debounce(this.searchTrainings, 500);
    this.searchThrottled = throttle(this.searchTrainings, 500);
  }

  componentDidMount() {
    this.searchTrainings();
  }

  

  searchTrainings = () => {
    const { page, rows, search, trainings } = this.state;
    this.setState({ loading: true });
    getTrainings({ page, rows, search, trainings }).then(

      (res) => {
        this.setState({
          trainings: res.trainings.data,
          employees: res.employees,
          branches:res.branches,
          trainers:res.trainers,
          training_types:res.training_types,
          page: res.trainings.current_page,
          total: res.trainings.total,
          loading: false,
        });
      },
      (error) => {
        this.setState({ loading: false });
      }
    );
  };

 

  onChange = (e, state) => {
    this.setState({ [state]: e });
  };

  onPage = async (page,rows) => {
    await this.setState({page,rows});
    await this.getTrainings();
  }
  
  handleSearch = event => {
    this.setState({ search: event.target.value }, () => {
      if(this.state.search < 5){
        this.searchThrottled(this.state.search);
      }else{
        this.searchDebounced(this.state.search);
      }
    
    });
  };
  
  toggleDeleteTraining=(deleteTraining)=>{
    this.setState({deleteTraining});
  }

  toggleEditTrainig = (training) => {
    this.setState({ training});
    this.searchTrainings();
   
  };
  toggleCloseTraining=(training)=>{
    this.setState({ training: !this.state.training });
  }

 

  toggleAddTraining = () => {
    this.setState({ addTraining: !this.state.addTraining });
    this.searchTrainings();
  }

  
  



  




  

  render() {
    const { employees, user, permission, deleteTraining, trainings, trainers, branches, training_types, training, total, page, rows, search, loading,addTraining, editTraining } = this.state;
    
    return (
      <>
       
        
        {addTraining && (
          <AddTraining
            saved={this.searchTrainings}
            employees={employees}
            trainers={trainers}
            training_types={training_types}
            branches={branches}
        
            toggle={this.toggleAddTraining}
            
          />
        )}

        {training && (
          <EditTraining
            saved={this.searchTrainings}
            training={training}
            employees={employees}
            trainers={trainers}
            training_types={training_types}
            branches={branches}
            toggle={this.toggleCloseTraining}
          />
        )}

        
        {deleteTraining && (
          <DeleteTraining
            saved={this.searchTrainings}
            deleteTraining={deleteTraining}
            toggle={() => this.setState({ deleteTraining: null })}
          />
        )}


      
       
        {loading && <SpinDiv text={"Loading..."} />}

        <Row style={{}}>
          <Col lg="12">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
              <div className="d-block mb-4 mb-md-0">
                <Breadcrumb
                  listProps={{
                    className: " breadcrumb-text-dark text-primary",
                  }}
                >
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href="#users">Trainings</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="btn-toolbar mb-2 mb-md-0">
                {user.admin == 1 && <ButtonGroup>
                  <Button variant="outline-primary" size="sm" onClick={() => this.toggleAddTraining()}>
                    Create Training
                  </Button>
                 
                  {permission &&  <Button variant="outline-primary"   onClick={() => {this.props.history.push('/training_types')}}  size="sm">
                    Create Training Types
                  </Button>} 
                 
          
                </ButtonGroup>}
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="8">
          <h5 className="mb-0">Trainings
          <span style={{color: '#aaa', fontSize: 14, fontWeight: 'normal'}}> ({total})</span></h5>
          </Col>
          <Col lg="4" className="">
            <div style={{ display: "flex" }}>
              <Input
                placeholder="Search..."
                autoFocus
                id="show"
                value={search}
                style={{ maxHeight: 45, marginRight: 5, marginBottom: 10 }}
                onChange={this.handleSearch}
                
              />
            </div>
          </Col>
        </Row>

        <Card border="light" className="shadow-sm mb-4">
          <Card.Body className="pb-0">
            <Table
              responsive
              className="table-centered table-nowrap rounded mb-0"
            >
              <thead className="thead-light">
                <tr>
                  <th className="border-0">Employees</th>
                  <th className="border-0">Title</th>
                  <th className="border-0">Progress</th>
                  <th className="border-0">Start Date</th>
                  <th className="border-0">End Date</th>
                  <th className="border-0">actions</th>
                </tr>
              </thead>
              <tbody>
                
                {trainings.map((training, key) => {
               
                  return (
                    <tr >
                      <th scope="row">
                      <td>
                        <Media className="align-items-center">
                          <a
                            className="avatar rounded-circle mr-3"
                            href="#p"
                            onClick={(e) => e.preventDefault()}
                          >
                            <img
                              style={{
                                maxHeight: 50,
                                maxWidth: 50,
                                borderRadius: '100%',
                              }}
                              alt="..."
                              src={
                                training.image ||
                                require("../../assets/img/brand/user.jpg")
                              }
                            />
                           
                          </a>
                          </Media>
                        </td>
                        <td>
                        <span style={{fontWeight:"bold",textTransform:"capitalize"}}>{training.name}</span>
                      </td>
                        
                      </th>
                      <td>
                        <span style={{fontWeight:"bold",textTransform:"capitalize"}}>{training.title}</span>
                      </td>
                        
                      <td>
                        <Progress percent={training.progress} status={training.progress < 50 ? 'exception':''} />
                      </td>
                      <td>{moment(training.start_date).format('MMM D, YYYY')}</td>
                      <td>{moment(training.end_date).format('MMM D, YYYY')}</td>
                    
                      <td>
                        
                        <ButtonGroup>
                          <Button variant="outline-primary" 
                          style={{fontWeight:"bold",textTransform:"capitalize"}} 
                          onClick={() => this.toggleEditTrainig(training)} size="sm">view</Button>
                          {user.admin == 1 && <Button
                            variant="outline-danger"

                            size="sm"
                            onClick={() => this.toggleDeleteTraining(training)}

                          >
                            Delete
                          </Button>}
                        </ButtonGroup>
                      </td>

                      
                      
                    </tr>
                  );
                })}
              </tbody>
             
            </Table>
            <Row>
              <Col md={12} style={{fontWeight:"bold",paddingTop:3}}>
              {trainings.length<1&&
                <div style={{color: '#ccc', alignSelf: 'center', padding: 10, fontSize: 13}}>
                  <i className="fa fa-ban" style={{marginRight: 5}}/>
                  No Trainings Registered for you
                </div>}
              {trainings.length > 0 && <Pagination
                  total={total}
                  showTotal={total => `Total ${total} trainings for all Employees`}
                  onChange={this.onPage}
                  pageSize={rows}
                  current={page}
                />}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export default TrainingIndex;
